import React from 'react'
import { useEffect, useState } from 'react'
import { isValidStr } from '../../common_functions'
import { Cookies } from 'react-cookie'
import { LOCATION, NAME_OF_EMPTY, SELECTED_LOCATION } from '../../constants/storageNames'
import AutoComplete from '../utilities/AutoComplete'

interface Props {
  changeInput: (query: string) => void
}

export function CommandPaletteSearchLocal({ changeInput }: Props) {
  const [query, setQuery] = useState('')

  const handleSendLocationManual = () => {
    let element = document.querySelector('#selectLocalManualInput') as HTMLInputElement
    let value = element?.value ?? query
    value = isValidStr(value) ? value : NAME_OF_EMPTY
    changeInput(value)
  }

  const handleSetQuery = (place:string) => {
    handleChangeQuery(place)
    setQuery(place)
  }

  const handleChangeQuery = (query:string) => {
    if(isValidStr(query)){
      sessionStorage.setItem(LOCATION, query)
      handleSendLocationManual()
    }
  }

  return (
    <div className="mx-auto max-w-xl transform divide-y absolute left-[3rem] mt-[5em] divide-gray-100 overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition-all">
      <div>
        <div className="relative">
          <svg
            className="pointer-events-none absolute left-4 top-3.5 h-5 w-5"
            aria-hidden="true"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 256"
          >
            <path d="M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z"></path>
          </svg>
          <AutoComplete
            apiKey={"AIzaSyBMJPirDqc93mEN0kEGA7f7jvfkZp-CcXc"}
            id="selectLocalManualInput"
            placeholder="Digite sua localização..."
            className='h-12 w-full border-0 me-3 bg-transparent pl-11 pr-4 place text-black placeholder:text-gray-600 outline-none focus:ring-0 sm:text-sm'
            onPlaceSelected={(place) => handleSetQuery(place ?? '')}
            options={{componentRestrictions: {country: 'br'}}}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="btnSendLocation"
            onClick={handleSendLocationManual}
            fill="currentColor"
            className="cursor-pointer absolute right-4 top-5 h-3 w-3"
            aria-hidden="true"
            viewBox="0 0 256 256"
          >
            <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
          </svg>
        </div>
      </div>
    </div>
  )
}
